import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQueries } from '@tanstack/react-query'

export const useProductThumbnail = (id: string) => {
  return useQueries({
    queries: [
      queries.products.detail(id),
      queries.products.notificationStatus(id),
    ],
    combine: (results) => {
      const detail = results[0].data
      if (!detail) return { pending: true, data: null }
      const notification = results[1].data

      const isSoftDeleted = !!detail.deletedAt
      const isSoldOut = !detail.isStock || isSoftDeleted
      const hasNotification = !!notification?.notifications?.length
      const showBanner =
        hasNotification && notification!.notifiedPrice >= detail.price.price
      const productTitle = detail.title
      const imageUrl = modifyImageSize(detail.imageUrl)

      return {
        pending: results.some((result) => result.isPending),
        data: {
          imageUrl,
          isSoftDeleted,
          isSoldOut,
          showBanner,
          productTitle,
        },
      }
    },
  })
}

const modifyImageSize = (url: string) => {
  // 정규식을 사용하여 492x492와 같은 패턴을 찾아 1000x1000으로 대체
  return url.replace(/(\d+)x(\d+)/, '1000x1000')
}
